/**
 * The query keys the account rail shares.
 *
 * In their own module because the rail is five pages that all read the same
 * organization - Profile, Users, Billing and Account now, then Activity - and a
 * page that invalidates a key it spelled itself would leave the others showing
 * what the save replaced.
 */

/** "My organization", as the Profile page reads and writes it. */
export const profileKey = ['account', 'profile'] as const;

/**
 * The same record as the top bar reads it, for its logo. One per organization,
 * because switching organization does not clear `profileKey`: without the id
 * the bar could show the logo of the organization just left. Under
 * `profileKey`, so invalidating that refreshes this too.
 */
export const organizationProfileKey = (organizationId: string | null) =>
  [...profileKey, organizationId] as const;

/** Everyone with a foot in the door, as the Users page reads it. */
export const usersKey = ['account', 'users'] as const;

/**
 * The commercial record, as Billing reads it and Account summarises it. One key
 * for both pages, so opening one after the other costs one request, and saving
 * the billing contact refreshes both.
 */
export const billingKey = ['account', 'billing'] as const;
